import { Trans } from 'react-i18next';

//  NOTE: if you changed names below, you must change names in i18n.js

export const spaceRoutes = {
  name: 'Space Data',
  to: '/space',
  icon: 'building',
  exact: true,
  children: [
    { to: '/space/energycategory', name: 'Energy Category Data' },
    { to: '/space/energyitem', name: 'Energy Item Data' },
    { to: '/space/carbon', name: 'Carbon' },
    { to: '/space/cost', name: 'Cost' },
    { to: '/space/output', name: 'Output' },
    { to: '/space/income', name: 'Income' },
    { to: '/space/efficiency', name: 'Efficiency' },
    { to: '/space/load', name: 'Load' },
    { to: '/space/statistics', name: 'Statistics' },
    { to: '/space/saving', name: 'Saving' },
    { to: '/space/plan', name: 'Plan' },
    { to: '/space/prediction', name: 'Prediction' },
    { to: '/space/environmentmonitor', name: 'Environment Monitor' },
    { to: '/space/enterproduction', name: 'Enter Production' },
    { to: '/space/production', name: 'Space Production' },
    { to: '/space/comparison', name: 'Space Comparison' }
  ]
};

export const equipmentRoutes = {
  name: 'Equipment Data',
  to: '/equipment',
  icon: 'cog',
  children: [
    { to: '/equipment/energycategory', name: 'Energy Category Data' },
    { to: '/equipment/energyitem', name: 'Energy Item Data' },
    { to: '/equipment/carbon', name: 'Carbon' },
    { to: '/equipment/cost', name: 'Cost' },
    { to: '/equipment/output', name: 'Output' },
    { to: '/equipment/income', name: 'Income' },
    { to: '/equipment/efficiency', name: 'Efficiency' },
    { to: '/equipment/load', name: 'Load' },
    { to: '/equipment/statistics', name: 'Statistics' },
    { to: '/equipment/saving', name: 'Saving' },
    { to: '/equipment/plan', name: 'Plan' },
    { to: '/equipment/batch', name: 'Batch Analysis' },
    { to: '/equipment/tracking', name: 'Equipment Tracking' },
    { to: '/equipment/comparison', name: 'Equipment Comparison' }
  ]
};

export const meterRoutes = {
  name: 'Meter Data',
  to: '/meter',
  icon: 'chart-pie',
  children: [
    { to: '/meter/meterenergy', name: 'Meter Energy' },
    { to: '/meter/metercarbon', name: 'Meter Carbon' },
    { to: '/meter/metercost', name: 'Meter Cost' },
    { to: '/meter/metertrend', name: 'Meter Trend' },
    { to: '/meter/meterrealtime', name: 'Meter Realtime' },
    { to: '/meter/metersaving', name: 'Meter Saving' },
    { to: '/meter/meterplan', name: 'Meter Plan' },
    { to: '/meter/metersubmetersbalance', name: 'Master Meter Submeters Balance' },
    { to: '/meter/meterbatch', name: 'Meter Batch Analysis' },
    { to: '/meter/metercomparison', name: 'Meter Comparison' },
    { to: '/meter/metertracking', name: 'Meter Tracking' },
    { to: '/meter/powerquality', name: 'Power Quality' },
    { to: '/meter/virtualmeterenergy', name: 'Virtual Meter Energy' },
    { to: '/meter/virtualmetercarbon', name: 'Virtual Meter Carbon' },
    { to: '/meter/virtualmetercost', name: 'Virtual Meter Cost' },
    { to: '/meter/virtualmeterbatch', name: 'Virtual Meter Batch Analysis' },
    { to: '/meter/virtualmetersaving', name: 'Virtual Meter Saving' },
    { to: '/meter/virtualmeterplan', name: 'Virtual Meter Plan' },
    { to: '/meter/virtualmetercomparison', name: 'Virtual Meter Comparison' },
    { to: '/meter/offlinemeterenergy', name: 'Offline Meter Energy' },
    { to: '/meter/offlinemetercarbon', name: 'Offline Meter Carbon' },
    { to: '/meter/offlinemetercost', name: 'Offline Meter Cost' },
    { to: '/meter/offlinemeterbatch', name: 'Offline Meter Batch Analysis' },
    { to: '/meter/offlinemetersaving', name: 'Offline Meter Saving' },
    { to: '/meter/offlinemeterplan', name: 'Offline Meter Plan' },
    { to: '/meter/offlinemeterinput', name: 'Offline Meter Input' }
  ]
};

// Microgrid
export const multipleMicrogridRoutes = {
  name: 'Multiple Microgrids',
  to: '/multiplemicrogrids',
  icon: 'industry',
  children: [
    { to: '/multiplemicrogrids/dashboard', name: 'Multiple Microgrids Dashboard' },
    { to: '/multiplemicrogrids/list', name: 'Multiple Microgrids List' },
  ]
};

// Microgrid
export const singleMicrogridRoutes = {
  name: 'Single Microgrid',
  to: '/singlemicrogrid',
  icon: 'building',
  children: [
    { to: '/singlemicrogrid/dashboard', name: 'Single Microgrid Dashboard' },
    { to: '/singlemicrogrid/details', name: 'Single Microgrid Details' },
    { to: '/singlemicrogrid/alarm', name: 'Single Microgrid Fault Alarm' },
  ]
};

// Microgrid
export const microgridReportsRoutes = {
  name: 'Microgrid Reports',
  to: '/microgridreports',
  icon: 'chart-pie',
  children: [
    { to: '/microgridreports/energy', name: 'Microgrid Reports Energy' },
    { to: '/microgridreports/revenue', name: 'Microgrid Reports Revenue' },
    { to: '/microgridreports/parameters', name: 'Microgrid Reports Parameters' },
  ]
};

export const combinedEquipmentRoutes = {
  name: 'Combined Equipment Data',
  to: '/combinedequipment',
  icon: 'cogs',
  children: [
    { to: '/combinedequipment/energycategory', name: 'Energy Category Data' },
    { to: '/combinedequipment/energyitem', name: 'Energy Item Data' },
    { to: '/combinedequipment/carbon', name: 'Carbon' },
    { to: '/combinedequipment/cost', name: 'Cost' },
    { to: '/combinedequipment/output', name: 'Output' },
    { to: '/combinedequipment/income', name: 'Income' },
    { to: '/combinedequipment/efficiency', name: 'Efficiency' },
    { to: '/combinedequipment/load', name: 'Load' },
    { to: '/combinedequipment/statistics', name: 'Statistics' },
    { to: '/combinedequipment/saving', name: 'Saving' },
    { to: '/combinedequipment/plan', name: 'Plan' },
    { to: '/combinedequipment/batch', name: 'Batch Analysis' },
    { to: '/combinedequipment/comparison', name: 'Combined Equipment Comparison' }
  ]
};

export const auxiliarySystemRoutes = {
  name: 'Auxiliary System',
  to: '/auxiliarysystem',
  icon: 'tv',
  children: [
    { to: '/auxiliarysystem/energyflowdiagram', name: 'Energy Flow Diagram' },
    { to: '/auxiliarysystem/distributionsystem', name: 'Distribution System' }
  ]
};
export const workOrderRoutes = {
  name: 'Work Order',
  to: '/workorder',
  icon: 'tools',
  children: [
    { to: '/workorder/installation', name: 'Work Order Installation' },
    { to: '/workorder/repair', name: 'Work Order Repair' },
    { to: '/workorder/inspection', name: 'Work Order Inspection' },
  ]
};

export const fddRoutes = {
  name: 'Fault Alarm',
  to: '/fdd',
  icon: 'bell'
};


export const knowledgeBaseRoutes = {
  name: 'Knowledge Base',
  to: '/knowledgebase',
  exact: true,
  icon: 'folder'
};

export default [
  spaceRoutes,
  equipmentRoutes,
  meterRoutes,
  combinedEquipmentRoutes,
  auxiliarySystemRoutes,
  multipleMicrogridRoutes,
  singleMicrogridRoutes,
  microgridReportsRoutes,
  workOrderRoutes,
  fddRoutes,
  knowledgeBaseRoutes
];
